import { render, staticRenderFns } from "./TableFive.vue?vue&type=template&id=89a36d38&scoped=true&"
import script from "./TableFive.vue?vue&type=script&lang=js&"
export * from "./TableFive.vue?vue&type=script&lang=js&"
import style0 from "./TableFive.vue?vue&type=style&index=0&id=89a36d38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a36d38",
  null
  
)

export default component.exports